import React from 'react'
import { Select, MenuItem, InputLabel, FormControl } from '@mui/material'

export interface PublicationType {
  id: number
  short_code: string
  description: string
}

export const publicationTypeOptions = new Map<number, PublicationType>([
  [1, { id: 1, short_code: 'BOK', description: 'Book' }],
  [2, { id: 2, short_code: 'MAG', description: 'Magazine' }],
  [3, { id: 3, short_code: 'NEW', description: 'Newsletter' }],
  [4, { id: 4, short_code: 'OTH', description: 'Other' }]
])

export const PublicationTypeSelect: React.FC<{ value: PublicationType | null, updatePublicationType: (publicationType: PublicationType | null) => void, disabled: boolean }> = ({ value, updatePublicationType, disabled }) => {
  const handleChange = (value: string | number): void => {
    const selectedOption = publicationTypeOptions.get(value as number)
    updatePublicationType(selectedOption ?? null)
  }

  return (
    <FormControl fullWidth variant="outlined">
      <InputLabel id="publication-type-select-label">Publication Type</InputLabel>
      <Select
        labelId="publication-type-select-label"
        label="Publication Type"
        value={(value != null) ? value.id : ''}
        onChange={(event) => { handleChange(event.target.value) }}
        disabled={disabled}
        fullWidth
      >
        {Array.from(publicationTypeOptions.values()).map((publicationType) => (
          <MenuItem key={publicationType.id} value={publicationType.id}>
            {publicationType.description}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
